import { render, staticRenderFns } from "./JointPaper.vue?vue&type=template&id=9602c462&scoped=true&"
import script from "./JointPaper.vue?vue&type=script&lang=js&"
export * from "./JointPaper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9602c462",
  null
  
)

export default component.exports